<script setup>
import {defineProps, onMounted, onUnmounted, ref} from "vue";
import {Swiper, SwiperSlide} from 'swiper/vue';
import {Navigation, Pagination, Scrollbar, A11y} from 'swiper/modules';
import factoryShowBack from '@/assets/img/factoryShowBack.png';
import factoryEquip_2 from '@/assets/img/factoryEquip_2.png';
import {CountTo} from 'vue3-count-to';
import 'swiper/css';

const modules = [Navigation, Pagination, Scrollbar, A11y];
const isVisible = ref(false);


const onSwiper = (swiper) => {
  console.log(swiper);
};

const onSlideChange = () => {
  console.log('slide change');
};
const props = defineProps({
  pictures: {
    type: Array,
    required: true,
  },
  importEquip: {
    type: Map
  }
});

onMounted(() => {
  const observer = new IntersectionObserver(
      ([entry]) => {
        isVisible.value = entry.isIntersecting;
      },
      {threshold: 0.5}
  );

  const target = document.querySelector('.num-count');
  if (target) observer.observe(target);

  onUnmounted(() => {
    observer.disconnect();
  });
});

</script>

<template>
  <div>
    <!--  首图-->

    <el-row>
      <el-col :span="24"
              :style="{
            display: 'flex',
            justifyContent: 'space-between',
            backgroundImage: `url(${factoryShowBack})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }">
        <!-- 左侧文字部分 -->
        <div style="flex: 1;text-align: left;padding-left: 10%;"
             class="gothamBold">
          <div class="equip_title" style="font-weight: lighter">
            <span>
            FACTORY DISPLAY
          </span>
            <br>
            <span>AND EQUIPMENT DISPLAY</span>
          </div>
          <div class="equip_content puHuiTi-regular">
            <span style="line-height: 1.5">高度定制化，贴合多样化生产需求，为您专属打造。智能监控系统实时保障运行，稳定可靠。于细微处精雕细琢，于宏观上掌控全局，以卓越生产能力。</span>
            <div>
              <el-image
                  style="width: 75%;margin-top: 2rem"
                  :src="factoryEquip_2"
                  fit="cover"
              />
            </div>

          </div>


        </div>

        <!-- 右侧图片部分 -->
        <el-image
            style="flex: 2; height: 25rem;margin-top: 5.5rem"
            :src="props.importEquip.img_url"
            fit="cover"
        />
      </el-col>
    </el-row>
    <div>

    </div>

    <div style="width: 100%;text-align: center;margin-top: 2.5rem;font-size: 2.5rem">
      <span class="gothamBold">EQUIPMENT DISPLAY</span>
      <div style="font-size: 1rem;width: 30%;margin-left: 35%;margin-top: 0.5rem">
        <span class="puHuiTi-regular" style="line-height: 1.5">高度定制化，贴合多样化生产需求，为您专属打造。智能监控系统实时保障运行，稳定可靠。于细微处精雕细琢，于宏观上掌控全局，以卓越生产能力。</span>
      </div>

    </div>
    <swiper
        :modules="modules"
        :slides-per-view="4"
        :space-between="50"
        navigation
        :pagination="{ clickable: true }"
        :scrollbar="{ draggable: true }"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        style="width: 83.333%;margin-top: 4rem;"
    >

      <swiper-slide style="width: 20%;background-color: white" v-for="(row, rowIndex) in props.pictures"
                    :key="rowIndex">
        <div style="height: 25rem">
          <div style="height: 80%">
            <el-image
                style="width: 80%;height: 80%;margin-top: 1.2rem"
                :src="row.img_url"
                fit="cover"
            />
          </div>
          <div class="gothamBold" style="height: 20%;text-align: left;margin-left: 10%;font-size: 1.5rem">
            Factory
          </div>

        </div>

      </swiper-slide>

    </swiper>
    <div style="padding-top: 3rem;height: 31rem">
      <div style="width: 100%;font-size: 2.5rem">
        <span class="gothamBold">DEVICE DATA</span>
        <div class="puHuiTi-regular" style="font-size: 1.5rem;font-weight: lighter">设备数据</div>
      </div>

      <div class="num-count gothamBold">
        <div style="text-align: left">
          <div style="width: 60%;margin-left: 40%">
            <count-to
                v-if="isVisible"
                style="font-size: 5rem; font-weight: lighter"
                :key="isVisible"
                :start-val="0"
                :end-val="200"
                :duration="3000"
            ></count-to>
            <span style="color: #777777;margin-left: 0.8rem" class="gothamBook">FACTORY</span>
            <div style="text-align: left;color: #777777" class="gothamBook">FACTORY DISPLAY</div>
          </div>

        </div>

        <div style="text-align: left">
          <div style="width: 60%;margin-left: 40%">
            <count-to
                v-if="isVisible"
                style="font-size: 5rem; font-weight: lighter"
                :key="isVisible"
                :start-val="0"
                :end-val="200"
                :duration="3000"
            ></count-to>
            <span style="color: #777777;margin-left: 0.8rem" class="gothamBook">FACTORY</span>
            <div style="text-align: left;color: #777777" class="gothamBook">FACTORY DISPLAY</div>
          </div>

        </div>

        <div style="text-align: left">
          <div style="width: 60%;margin-left: 40%">
            <count-to
                v-if="isVisible"
                style="font-size: 5rem; font-weight: lighter"
                :key="isVisible"
                :start-val="0"
                :end-val="200"
                :duration="3000"
            ></count-to>
            <span style="color: #777777;margin-left: 0.8rem" class="gothamBook">FACTORY</span>
            <div style="text-align: left;color: #777777" class="gothamBook">FACTORY DISPLAY</div>
          </div>

        </div>


      </div>

      <div class="num-count gothamBold">
        <div style="text-align: left">
          <div style="width: 60%;margin-left: 40%">
            <count-to
                v-if="isVisible"
                style="font-size: 5rem; font-weight: lighter"
                :key="isVisible"
                :start-val="0"
                :end-val="200"
                :duration="3000"
            ></count-to>
            <span style="color: #777777;margin-left: 0.8rem" class="gothamBook">FACTORY</span>
            <div style="text-align: left;color: #777777" class="gothamBook">FACTORY DISPLAY</div>
          </div>

        </div>

        <div style="text-align: left">
          <div style="width: 60%;margin-left: 40%">
            <count-to
                v-if="isVisible"
                style="font-size: 5rem; font-weight: lighter"
                :key="isVisible"
                :start-val="0"
                :end-val="200"
                :duration="3000"
            ></count-to>
            <span style="color: #777777;margin-left: 0.8rem" class="gothamBook">FACTORY</span>
            <div style="text-align: left;color: #777777" class="gothamBook">FACTORY DISPLAY</div>
          </div>

        </div>

        <div style="text-align: left">
          <div style="width: 60%;margin-left: 40%">
            <count-to
                v-if="isVisible"
                style="font-size: 5rem; font-weight: lighter"
                :key="isVisible"
                :start-val="0"
                :end-val="200"
                :duration="3000"
            ></count-to>
            <span style="color: #777777;margin-left: 0.8rem" class="gothamBook">FACTORY</span>
            <div style="text-align: left;color: #777777" class="gothamBook">FACTORY DISPLAY</div>
          </div>

        </div>


      </div>

    </div>
  </div>
</template>

<style scoped>
.equip_title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-left: 20%;
  margin-top: 3rem;
}

.equip_content {
  margin-left: 20%;
  margin-top: 2rem;
}

.num-count {
  display: flex;
  color: #2c5bb3;
  margin-top: 3rem;
}

.num-count > div {
  flex: 1;
}


</style>